export default class Authorizer {
    private _bearer: string = '';

    constructor(bearer: string) {
        this._bearer = bearer;
    }

    public set bearer(bearer: string) {
        this._bearer = bearer;
    }

    public get bearer() {
        return this._bearer;
    }

    public authorize(headers: Headers) {
        headers.append('Authorization', `Bearer ${this.bearer}`);
    }
}
